import {Injectable} from '@angular/core';
import {ApiListDataService} from './api.list-data.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiDictionariesByNameService extends ApiListDataService<any, any> {

  constructor(http: HttpClient) {
    super(http, '/Dictionaries/byCode/');
  }
}
